module.exports = __webpack_public_path__ + "static/img/recordf1.f2abc556.png";